// AboutPage.js

import React from 'react';


const AboutPage = () => {
  return (
    
    <div className='page-content'>
      <h2>About Page</h2>
      {/* Contenuto della About Page */}
    </div>
    
  );

};

export default AboutPage;
